import React, {
  useEffect,
  useReducer,
  useContext,
  createContext,
  useState,
  useCallback,
} from "react";

import ChartReducer from "../Reducer/ChartReducer"; // adjust the path as needed
const initialState = {
  trainDetentionCodeWise: {
    data: null,
    time_duration: null,
  },

  bestSheetDataObj: {
    bestSheetData: null,
    fyTotal: null,
    visibleTable: {},
    loading: false,
    columnName: null,
    error: false,
  },
  commodityWiseLObj: {
    commodityWiseLo: null,
    fyTotal: null,
    visibleTable: {},
    loading: false,
    error: false,
  },
  railRoadObj: {
    railRoad: null,
    fyTotal: null,
    visibleTable: {},
    loading: false,
    error: false,
  },
  test: null,
};

const ChartContext = createContext();

export const ChartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ChartReducer, initialState);
  ////////////////////////// Fetch Data best sheet////////////
  const fetchBestSheetData = useCallback(async () => {
    dispatch({ type: "SET_BEST_SHEET_DATA_BEGAN" });

    const url = `${process.env.REACT_APP_URL_PREFIX}bestsheet`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Check if the data structure exists

      if (data?.bestsheet?.length > 0) {
        dispatch({ type: "SET_BEST_SHEET_DATA", payload: data });
      }
    } catch (error) {
      dispatch({ type: "SET_BEST_SHEET_DATA_FAIL", payload: error });
      console.error("Error fetching data:", error);
      // setError(true);
    } finally {
      dispatch({ type: "SET_BEST_SHEET_DATA_FETCH_END" });
    }
  }, []);
  ////////////////////////// Fetch COMMODITY_WISE sheet////////////
  const fetchCommodityWiseData = useCallback(async () => {
    dispatch({ type: "SET_COMMODITY_WISE_DATA_BEGAN" });

    const url = `${process.env.REACT_APP_URL_PREFIX}communitywise`;
    // const url = `http://localhost:5000/communitywise`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Check if the data structure exists

      if (data?.status === "ok") {
        dispatch({ type: "SET_COMMODITY_WISE_DATA", payload: data });
      }
    } catch (error) {
      dispatch({ type: "SET_COMMODITY_WISE_DATA_FAIL", payload: error });
      console.error("Error fetching data:", error);
      // setError(true);
    } finally {
      dispatch({ type: "SET_COMMODITY_WISE_DATA_FETCH_END" });
    }
  }, []);
  ////////////////////////// Fetch Rail road ////////////////////////////
  const fetchRailRoadData = async () => {
    dispatch({ type: "SET_RAIL_ROAD_WISE_DATA_BEGAN" });

    const url = `${process.env.REACT_APP_URL_PREFIX}railroddata`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Check if the data structure exists

      if (data?.status === "ok") {
        dispatch({ type: "SET_RAIL_ROAD_WISE_DATA", payload: data });
      }
    } catch (error) {
      dispatch({ type: "SET_RAIL_ROAD_WISE_DATA_FAIL", payload: error });
      console.error("Error fetching data:", error);
      // setError(true);
    } finally {
      dispatch({ type: "SET_RAIL_ROAD_WISE_FETCH_END" });
    }
  };
  // /////////////////////////(////////////////////////////////////////////////////////////////////////////////////////////////////
  const setTrainDetentionCodeWise = (data) => {
    dispatch({ type: "SET_DATA_TRAIN_DETENTION_WISE", payload: data });
  };
  // const setBestSheetData = (data) => {
  //   dispatch({ type: "SET_BEST_SHEET_DATA", payload: data });
  // };
  const setVisibleTable = (showTable) => {
    dispatch({ type: "SET_VISIBLE_TABLE", payload: showTable });
  };
  return (
    <ChartContext.Provider
      value={{
        ...state,
        setTrainDetentionCodeWise,
        // setBestSheetData,
        setVisibleTable,
        fetchBestSheetData,
        fetchCommodityWiseData,
        fetchRailRoadData,
      }}
    >
      {children}
    </ChartContext.Provider>
  );
};

export const useChartContext = () => {
  return useContext(ChartContext);
};

export { ChartContext };
